var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.query)?_c('a',{staticClass:"ytcid-link",attrs:{"href":_vm.href,"target":"_blank","rel":"noopener","title":`YouTube Content ID에서 '${_vm.query}' 검색`}},[_c('span',{staticClass:"ytcid-link__dot",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"ytcid-link__label"},[_vm._v("Content ID 검색")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }